import { ReportOperationDataCommand } from "./report-operation-data-command";
import { GetOperationHandler } from "../../../../../../common/cqrs/query/get-operation/get-operation-handler";
import { GetOperationQuery } from "../../../../../../common/cqrs/query/get-operation/get-operation-query";
import { SupportTicketLanguage, SupportTicketTechnology } from "../../../../support-ticket/support-ticket-options-provider";
import { httpPatch } from "../../../../../../common/network/fetch";
import { t } from "i18next";

export const ReportOperationDataCommandHandler = async (command: ReportOperationDataCommand) => {
    const operation = await GetOperationHandler(new GetOperationQuery(command.operationCode));

    if (!operation) {
        throw new Error(t("components.operationDataValidation.report.ticket.operationNotFound", { operationCode: command.operationCode }));
    }

    return await httpPatch<string>({
        url: `/operations/reporting/${command.operationCode}/report-issue`,
        data: {
            warehouseId: operation.warehouseId,
            spokenLanguage: command.locale === "fr-FR" ? SupportTicketLanguage.French : SupportTicketLanguage.English,
            topic: "SupplierSupport",
            technology: SupportTicketTechnology.ClickAndShip,
            description: command.description,
            contactName: command.contactName,
            contactEmail: command.contactEmail,
            contactPhone: command.contactPhone,
            contactPreferences: "",
            attachments: [],
            team: "France",
            supplier: "Brand",
            severity: "ProductionSlowedDown",
            issue: command.issueValue ?? "IssueWithOperationData",
        }});
};
